var __jsx = React.createElement;
import APP_CONFIGURATION from "@lib/app.config";
import { cn } from "@lib/cn";
import useCssModules from "@lib/hooks/use-css-modules";
import Icons from "@modules/icons";
import React from "react";
const InformativeCard = _ref => {
  var _APP_CONFIGURATION$in, _APP_CONFIGURATION$in2;
  let {
    message,
    severity = "info",
    className,
    iconColor
  } = _ref;
  const {
    cssModules
  } = useCssModules();
  const mode = ((_APP_CONFIGURATION$in = APP_CONFIGURATION.informativeCard) === null || _APP_CONFIGURATION$in === void 0 ? void 0 : _APP_CONFIGURATION$in.mode) || "neutral";
  const deleteBorder = ((_APP_CONFIGURATION$in2 = APP_CONFIGURATION.informativeCard) === null || _APP_CONFIGURATION$in2 === void 0 ? void 0 : _APP_CONFIGURATION$in2.deleteBorder) || false;
  const baseStyles = "flex flex-row rounded-xl w-full shadow-md";
  const modeBaseStyles = {
    neutral: "text-psm-regular text-black_neutral p-4 gap-[6px]",
    tooltip: cn("text-psm-regular text-primary_text p-4 gap-[6px]", (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.baseContainer) || "")
  };
  const severityStyles = {
    neutral: {
      danger: {
        container: "bg-error-main text-white",
        icon: __jsx(Icons.circleXFilled, {
          size: 16,
          color: APP_CONFIGURATION.colors.white
        }),
        textClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.dangerText,
        tooltipClass: ""
      },
      info: {
        container: "bg-neutral-100 text-flights-form-disclaimer_text",
        icon: __jsx(Icons.infoCardInfo, {
          size: 16,
          color: APP_CONFIGURATION.colors.flights.form.disclaimer_text
        }),
        textClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.infoText,
        tooltipClass: ""
      },
      warning: {
        container: "bg-warning-main text-white",
        icon: __jsx(Icons.triangleFilledExclamation, {
          size: 16,
          color: APP_CONFIGURATION.colors.white
        }),
        textClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.warningText,
        tooltipClass: ""
      }
    },
    tooltip: {
      danger: {
        container: cn("bg-error-500", deleteBorder ? "border-none" : "border-error-500"),
        icon: __jsx(Icons.circleXFilled, {
          className: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.dangerIcon
        }),
        tooltipClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.tooltipDanger,
        textClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.dangerText
      },
      info: {
        container: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.infoContainer,
        icon: __jsx(Icons.infoCardInfo, {
          className: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.infoIcon
        }),
        tooltipClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.tooltipInfo,
        textClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.infoText
      },
      warning: {
        container: cn("bg-[#FFF5E1]", deleteBorder ? "border-none" : "border-warning-500"),
        icon: __jsx(Icons.triangleFilledExclamation, {
          className: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.warningIcon
        }),
        tooltipClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.tooltipWarning,
        textClass: cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.informativeCard.warningText
      }
    }
  };
  const currentSeverityStyles = severityStyles[mode][severity];
  return __jsx("div", {
    className: cn(baseStyles, modeBaseStyles[mode], currentSeverityStyles.container, className)
  }, mode === "tooltip" && __jsx("div", {
    className: currentSeverityStyles.tooltipClass
  }), __jsx("div", {
    className: "min-h-full min-w-fit flex items-center justify-center"
  }, currentSeverityStyles.icon), __jsx("div", {
    className: currentSeverityStyles.textClass
  }, message));
};
export default InformativeCard;